import { createReducer, on } from '@ngrx/store';
import {
  storeActiveOutcomeDocument,
  storeOutcomes,
  storeStudyIdOutcome,
} from './outcome.actions';
import { Outcomes } from '../models';
import { Document } from '@documents/models/document-type';

export interface OutcomeState {
  outcomes?: Outcomes[];
  studyId?: string;
  total?: number;
  activeDocument?: Document | undefined;
}

const initialState: OutcomeState = {
  outcomes: [],
  studyId: '',
  total: 0,
};

export const outcomesReducer = createReducer(
  initialState,
  on(storeOutcomes, (state, { outcomes, total }) => ({
    ...state,
    outcomes: outcomes,
    total: total,
  })),

  on(storeActiveOutcomeDocument, (state, { document }) => ({
    ...state,
    activeDocument: document,
  })),

  on(storeStudyIdOutcome, (state, { studyId }) => ({
    ...state,
    studyId: studyId,
  })),
);
